// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L4kTk{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.WryFz{font-family:"Inter",sans-serif}
.nCvVq{background-color:#fff;border-radius:16px 16px 0 0;font-family:"Inter",sans-serif;top:-8px;position:relative;padding-top:48px;padding-bottom:24px;-webkit-box-shadow:0 -4px 20px -4px rgba(0,0,0,.04);box-shadow:0 -4px 20px -4px rgba(0,0,0,.04)}
.eqhlf{font-weight:700;font-size:28px;color:#0f172a;letter-spacing:-0.5px;line-height:1.3;margin-bottom:0}
.shs3Z{margin-top:12px;font-weight:400;font-size:16px;color:#64748b;letter-spacing:-0.1px;line-height:1.6;margin-left:auto;margin-right:auto}
.C6_RJ{color:#64748b;font-size:12px;font-size:.75rem;font-weight:400;line-height:1.4;margin-top:8px;margin-top:.5rem}
.SmV5r{font-size:18px;color:#64748b;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `L4kTk`,
	"baseContainer": `WryFz`,
	"formContainer": `nCvVq`,
	"title": `eqhlf`,
	"subtitle": `shs3Z`,
	"helperText": `C6_RJ`,
	"optionLabel": `SmV5r`
};
module.exports = ___CSS_LOADER_EXPORT___;
